module.exports = __webpack_public_path__ + "static/img/index3.f05fb3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company/index3.png
// module id = P/XY
// module chunks = 1